export default {
    init: function () {

    jQuery(function($){	
            $('.de-page-search .de-search-nav ul.de-tiny-caps').css('display', 'none');
        
            $('.de-page-search .de-search-nav a.de-border-caps').click(function() {
                $('.de-page-search .de-search-nav a.de-border-caps').not(this).next().slideUp(300);
                $('.de-page-search .de-search-nav a.de-border-caps').not(this).removeClass('open');
                $(this).toggleClass('open').next().slideToggle(300);
            });
        
            $('.de-search-results.js-article').hide();
        
            $('.js-product-trigger').click(function() {
                $('.de-search-results.js-product').fadeIn();
                $('.de-search-results.js-article').fadeOut();
            });
            $('.js-article-trigger').click(function() {
                $('.de-search-results.js-article').fadeIn();
                $('.de-search-results.js-product').fadeOut();
            });
        
        });
    }
};
